import React, { useEffect } from 'react';

const TawkToChat = () => {
  useEffect(() => {
    // Create Tawk_API if it doesn't exist
    if (typeof window !== 'undefined') {
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();
    }

    // Create and append the Tawk.to script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/67a74bea3a842732607bd899/1ijio134k';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    // Append the script to the document
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    // Cleanup function to remove the script when component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      // Clean up Tawk_API
      if (typeof window !== 'undefined') {
        delete window.Tawk_API;
        delete window.Tawk_LoadStart;
      }
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return null; // This component doesn't render anything
};

export default TawkToChat; 